/**
 * Pick the station to keep selected when the list changes: keep the current one
 * if it is still present, otherwise default to the first station (or nothing
 * when the list is empty). Typed structurally so it stays trivially testable.
 */
export function resolveDefaultStationId(
  stations: readonly { id: string }[],
  current: string | undefined,
): string | undefined {
  if (stations.length === 0) return undefined;
  if (current && stations.some((station) => station.id === current)) return current;
  return stations[0].id;
}
